import React from 'react';
import { Box, Typography, Container, Paper, Grid, Card, CardContent, CardActions, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const blogPosts = [
  {
    id: 1,
    title: 'Getting Started with Service Monitoring',
    excerpt: 'Learn the basics of setting up your first service monitor...',
    date: '2024-11-01'
  },
  {
    id: 2,
    title: 'Best Practices for Uptime Monitoring',
    excerpt: 'Discover industry best practices for maintaining high availability...',
    date: '2024-10-15'
  },
  {
    id: 3,
    title: 'Understanding SLA Metrics',
    excerpt: 'Deep dive into Service Level Agreement metrics and why they matter...',
    date: '2024-10-01'
  }
];

export default function Blog() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h3" gutterBottom>
        Blog
      </Typography>
      <Typography variant="body1" paragraph sx={{ mb: 4 }}>
        Latest updates and insights about service monitoring
      </Typography>

      <Grid container spacing={3}>
        {blogPosts.map(post => (
          <Grid item xs={12} md={4} key={post.id}>
            <Card>
              <CardContent>
                <Typography variant="caption" color="text.secondary">
                  {post.date}
                </Typography>
                <Typography variant="h5" component="h2" gutterBottom>
                  {post.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {post.excerpt}
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="small" onClick={() => navigate(`/blog/${post.id}`)}>
                  Read More
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

